import React from "react";
import { Navigate } from "react-router-dom";

//----------------------------------------Dashboard----------------------------------------
import Dashboard from "../Pages/Dashboard";

//----------------------------------------Import Calender----------------------------------
import Calender from "../Pages/Calender";

//----------------------------------------Import Authentication pages----------------------
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import EnableUser from "../Pages/Users/CompleteRegistration";
import UserProfile from "../Pages/Authentication/user-profile";
import Recover from "../Pages/Authentication/Recover";
import ResetPassword from "../Pages/AuthenticationPages/ResetPassword";
import RecoverPassword from "../Pages/Authentication/RecoverPassword";

//----------------------------------------Import Authentication Inner Pages----------------
import Login1 from "../Pages/AuthenticationPages/Login";
import Register1 from "../Pages/AuthenticationPages/Register";
import LockScreen from "../Pages/AuthenticationPages/LockScreen";

//----------------------------------------User list----------------------------------------
import UserList from "../Pages/Users/UserList";
import UserDetails from "../Pages/Users/UserDetails/UserDetails";
import CreateUserForm from "../Pages/Users/CreateUserForm";
import EditUserForm from "../Pages/Users/EditUserForm";

//----------------------------------------Organisation list--------------------------------
import OrganisationList from "../Pages/Organisations/OrganisationList";
import AddOrganisation from "../Pages/Organisations/AddOrganisation";
import OrganisationDetails from "../Pages/Organisations/OrganisationDetails";

//----------------------------------------Device list--------------------------------------
import DeviceList from "../Pages/Devices/DeviceList";
import EditDevice from "../Pages/Devices/EditDevice";
import CreateDevice from "../Pages/Devices/CreateDevice";
import DeviceDetails from "../Pages/Devices/DeviceDetails";

//----------------------------------------Master device list-------------------------------
import MasterDevice from "../Pages/Devices/MasterDevice/MasterDevice";
import MasterDetails from "../Pages/Devices/MasterDevice/MasterDetails";
import CreateMasterDevice from "../Pages/Devices/MasterDevice/CreateMasterDevice";
import EditMasterDevice from "../Pages/Devices/MasterDevice/EditMasterDevice";
import UpdateRoom from "../Pages/Devices/Group/UpdateRoom";

//----------------------------------------Product------------------------------------------
import ProductList from "../Pages/Products/ProductList";

//Zone 
import ZoneList from "../Pages/Zones/ZoneList";

//----------------------------------------Approval----------------------------------------
import ApprovalsList from "../Pages/Approvals/ApprovalsList";

//----------------------------------------Request-----------------------------------------
import RequestList from "../Pages/Requests/RequestList";
import ReturnRequestsList from "../Pages/ReturnRequest/ReturnRequestsList";
import ReturnApprovalsList from "../Pages/ReturnApprovals/ReturnApprovalsList";

//----------------------------------------Settings-----------------------------------------
import ReturnReasonList from "../Pages/Settings/ReturnReason/ReturnReasonList";
import AppVersionList from "../Pages/AppVersion/AppVersionList";

const authProtectedRoutes = [
  //----------------------------------------dashboard--------------------------------------
  { path: "/dashboard", component: <Dashboard /> },

  //----------------------------------------Organisation-----------------------------------
  { path: "/orglist", component: <OrganisationList /> },
  { path: "/orglist/add", component: <AddOrganisation /> },
  { path: "/orglist/details/:id", component: <OrganisationDetails /> },

  //----------------------------------------User list--------------------------------------
  { path: "/userlist", component: <UserList /> },
  { path: "/userlist/details/:id", component: <UserDetails /> },
  { path: 'userlist/details/:id/edit', component: <EditUserForm />, },
  { path: 'userlist/add', component: <CreateUserForm />, },
  { path: "/productlist", component: <ProductList /> },

  //----------------------------------------Device-----------------------------------------
  { path: '/devicelist/details/:id', component: <DeviceDetails /> },
  { path: 'devicelist/add', component: <CreateDevice />, },
  { path: 'devicelist/details/:id/edit', component: <EditDevice />, },
  { path: "/devicelist", component: <DeviceList /> },
  { path: "/returnrequest", component: <ReturnRequestsList /> },
  { path: "/returnapproval", component: <ReturnApprovalsList /> },

  //----------------------------------------Master Device-----------------------------------
  { path: "devicelist/master-devices", component: <MasterDevice /> },
  { path: "devicelist/master-devices-customers", component: <MasterDevice /> },
  { path: "/devicelist/master-devices/details/:id", component: <MasterDetails /> },
  { path: "/devicelist/master-devices-customers/details/:id", component: <MasterDetails /> },
  { path: "/devicelist/master-devices-customers/details/:id/edit", component: <EditMasterDevice /> },
  { path: "/devicelist/master-devices/details/:id/edit", component: <EditMasterDevice /> },
  { path: "devicelist/master-devices/details/:id/:key/update-room", component: <UpdateRoom /> },
  { path: "devicelist/master-devices-customers/details/:id/:key/update-room", component: <UpdateRoom /> },
  { path: "/devicelist/master-devices/add", component: <CreateMasterDevice /> },
  { path: "/zonelist", component: <ZoneList /> },

  //----------------------------------------Request----------------------------------------
  { path: '/requestlist', component: <RequestList />, },

  //----------------------------------------Approvals--------------------------------------
  { path: '/approvallist', component: <ApprovalsList /> },

  //----------------------------------------App Version------------------------------------
  { path: '/appversionlist', component: <AppVersionList /> },

  // ----------------------------------------Calender--------------------------------------
  { path: "/calendar", component: <Calender /> },

  //----------------------------------------Profile----------------------------------------
  { path: "/userprofile", component: <UserProfile /> },
  { path: "/", exact: true, component: <Navigate to="/login" />, },

  //----------------------------------------Settings---------------------------------------
  { path: "/settings/returnreason", component: <ReturnReasonList /> },

];
const publicRoutes = [
  // Authentication Page
  { path: "/", component: <Login /> },
  { path: "/ResetPassword/:code", component: <ForgetPasswordPage /> },
  { path: "/enableuseraccount/:code", component: <EnableUser /> },
  // { path: '/recover', element: <Recover /> },
  { path: "/auth-recoverpw", component: <RecoverPassword /> },
  // Authentication Inner Pages
  // { path: "/auth-login", component: <Login1 /> },
  // { path: "/auth-register", component: <Register1 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  // { path: 'auth/resetpassword/:code', element: <ResetPassword /> },

];

export { authProtectedRoutes, publicRoutes };
